import { library } from '@fortawesome/fontawesome-svg-core';
import { faTwitter, faGoogle, faApple, faMeta, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faUser, faLock, faCamera,
    faArrowRightFromBracket, faGift, faArrowTrendUp, faFileShield,
    faSquarePollVertical, faCircleCheck, faBook, faPowerOff, faUsers, faCheck,
    faCircleNotch } from '@fortawesome/free-solid-svg-icons';

library.add(faUser,
    faLock, faCamera, faLock, faGoogle, faApple,
    faMeta, faFacebook, faArrowRightFromBracket,
    faGift, faArrowTrendUp, faFileShield, faSquarePollVertical,
    faCircleCheck, faBook, faPowerOff, faUsers, faCheck, faCircleNotch)